import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {

  transform(value: Array<string | object>, input: string, keys?: string[]) {
    if (!Array.isArray(value) || typeof input !== 'string' || !input)
      return value;

    input = input.toLowerCase();

    return value.filter(element => {
      if (typeof element === 'string' && element.toLowerCase().includes(input))
        return true;

      if (typeof element === 'object') {
        for (let key of keys) {
          if (element[key] !== undefined && String(element[key]).toLowerCase().includes(input)) {
            return true;
          }
        }
      }

      return false;
    });
  }
}
